export enum AutoProduct {
  Bike = 'bike',
  Car = 'car',
}

export enum AutoWidgetVariant {
  SemVariant = 'semWidget',
  SeoVariant = 'seoWidget',
}
